export default __webpack_public_path__ + "static/media/Gellix-ExtraBoldItalic.23a13566.woff2";